import React, { useState } from 'react';
import { Briefcase, MapPin, Clock, DollarSign, ChevronRight, Users, TrendingUp, Heart, Award } from 'lucide-react';
import './CareersPage.css';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CareersPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    experience: '',
    coverLetter: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const jobOpenings = [
    {
      title: 'Senior Petroleum Engineer',
      location: 'Warsaw, Poland',
      type: 'Full-time',
      salary: '€85,000 - €115,000',
      department: 'Engineering',
      description: 'Lead reservoir engineering projects and optimize production operations'
    },
    {
      title: 'Refinery Operations Manager',
      location: 'Gdansk, Poland',
      type: 'Full-time',
      salary: '€95,000 - €130,000',
      department: 'Operations',
      description: 'Oversee refinery operations ensuring safety, efficiency, and compliance'
    },
    {
      title: 'HSE Specialist',
      location: 'Multi-Site Europe',
      type: 'Full-time',
      salary: '€60,000 - €80,000',
      department: 'Safety',
      description: 'Develop and implement health, safety, and environmental programs'
    },
    {
      title: 'Data Analyst - Operations',
      location: 'Remote (Europe)',
      type: 'Full-time',
      salary: '€65,000 - €85,000',
      department: 'Technology',
      description: 'Analyze operational data to drive efficiency improvements'
    },
    {
      title: 'Mechanical Engineer',
      location: 'Katowice, Poland',
      type: 'Full-time',
      salary: '€68,000 - €90,000',
      department: 'Engineering',
      description: 'Design and maintain mechanical systems for processing facilities'
    },
    {
      title: 'Supply Chain Coordinator',
      location: 'Warsaw, Poland',
      type: 'Full-time',
      salary: '€50,000 - €65,000',
      department: 'Logistics',
      description: 'Coordinate crude oil and product logistics across distribution network'
    }
  ];

  const benefits = [
    {
      icon: <Heart size={32} />,
      title: 'Health & Wellness',
      description: 'Comprehensive medical, dental, and vision coverage for you and your family'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Career Growth',
      description: 'Professional development programs and clear advancement pathways'
    },
    {
      icon: <DollarSign size={32} />,
      title: 'Competitive Compensation',
      description: 'Industry-leading salaries, bonuses, and profit-sharing programs'
    },
    {
      icon: <Award size={32} />,
      title: 'Work-Life Balance',
      description: 'Flexible schedules, generous PTO, and family support programs'
    }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.experience) {
      toast.error('Please select your experience level');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${API}/careers/apply`, formData);
      
      if (response.data.success) {
        toast.success(response.data.message);
        setFormData({
          name: '',
          email: '',
          phone: '',
          position: '',
          experience: '',
          coverLetter: ''
        });
      }
    } catch (error) {
      console.error('Error submitting career application:', error);
      toast.error(error.response?.data?.detail || 'Failed to submit application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="careers-page">
      <section className="careers-hero">
        <div className="careers-hero-overlay"></div>
        <div className="careers-hero-content">
          <h1>Join Our Team</h1>
          <p>Build your career with an industry leader committed to excellence and innovation</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Why Work With Us</h2>
          <p className="section-subtitle">
            Join a team of dedicated professionals shaping the future of energy
          </p>

          <div className="culture-content">
            <p>
              At {companyName}, we believe our people are our greatest asset. We foster a culture of safety, collaboration, and continuous improvement where every team member contributes to our success. With industry-leading training programs, competitive compensation, and commitment to work-life balance, we provide an environment where careers thrive.
            </p>
          </div>

          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
	
	{/*
      <section className="openings-section section">
        <div className="container">
          <h2 className="section-title">Current Openings</h2>
          <p className="section-subtitle">
            Explore opportunities across our operations
          </p>

          <div className="jobs-grid">
            {jobOpenings.map((job, index) => (
              <div key={index} className="job-card">
                <div className="job-header">
                  <h3>{job.title}</h3>
                  <span className="job-department">{job.department}</span>
                </div>
                <p className="job-description">{job.description}</p>
                <div className="job-meta">
                  <span>
                    <MapPin size={16} />
                    {job.location}
                  </span>
                  <span>
                    <Clock size={16} />
                    {job.type}
                  </span>
                  <span>
                    <DollarSign size={16} />
                    {job.salary}
                  </span>
                </div>
                <button className="job-apply-btn">
                  Apply Now
                  <ChevronRight size={18} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
	*/}

	
      <section className="application-section section">
		
        <div className="container">
		{/*
          <h2 className="section-title">Submit Your Application</h2>
          <p className="section-subtitle">
           Send us your resume and we'll keep you in mind for future opportunities
          </p>
		  onSubmit={handleSubmit}
		   */}
		  
          <div className="application-form-wrapper">
            <form className="application-form" action="/contact" >
			
				{/*
              <div className="form-row">
                <div className="form-group">
                  <Label htmlFor="name">Full Name *</Label>
                  <Input
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="John Doe"
                  />
                </div>
                <div className="form-group">
                  <Label htmlFor="email">Email Address *</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="john.doe@example.com"
                  />
                </div>
              </div>
			 
              <div className="form-row">
                <div className="form-group">
                  <Label htmlFor="phone">Phone Number *</Label>
                  <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="(555) 123-4567"
                  />
                </div>
                <div className="form-group">
                  <Label htmlFor="position">Position of Interest *</Label>
                  <Input
                    id="position"
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                    required
                    placeholder="e.g., Petroleum Engineer"
                  />
                </div>
              </div>

              <div className="form-group">
                <Label htmlFor="experience">Years of Experience *</Label>
                <Select name="experience" value={formData.experience} onValueChange={(value) => setFormData({...formData, experience: value})}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select experience level" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="0-2">0-2 years</SelectItem>
                    <SelectItem value="3-5">3-5 years</SelectItem>
                    <SelectItem value="6-10">6-10 years</SelectItem>
                    <SelectItem value="10+">10+ years</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="form-group">
                <Label htmlFor="coverLetter">Cover Letter / Additional Information</Label>
                <Textarea
                  id="coverLetter"
                  name="coverLetter"
                  value={formData.coverLetter}
                  onChange={handleChange}
                  rows={6}
                  placeholder="Tell us about your experience and why you'd like to join our team..."
                />
              </div>
			   */}

              <div className="form-actions">
                <Button type="submit" className="submit-btn" disabled={isSubmitting}>
                  <Briefcase size={18} />
                  {isSubmitting ? 'Submitting...' : 'Submit Application'}
                </Button>
              </div>
            </form>
          </div>
        </div>
			
      </section>	
	  
    </div>
  );
};

export default CareersPage;